<template>
  <div>
    <b-card>
      <b-card-header>
        <b-card-title class="mb-0">Trends (last 12 months)</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-card class="filter-panel mb-2">
          <b-row>
            <b-col cols="12" md="6" lg="4" xl="2" class="mb-1">
              <label class="filter-label">Companies</label>
              <v-select :options="companies" :multiple="true" label="label" v-model="filters.company" @input="loadData" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllCompanies">Select All</b-button>
            </b-col>
            <b-col cols="12" md="6" lg="4" xl="2" class="mb-1">
              <label class="filter-label">Courses</label>
              <v-select :options="courses" :multiple="true" label="label" v-model="filters.course" @input="loadData" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllCourses">Select All</b-button>
            </b-col>
            <b-col cols="12" md="6" lg="4" xl="2" class="mb-1">
              <label class="filter-label">Sites</label>
              <v-select :options="filteredSites" :multiple="true" label="label" v-model="filters.site" @input="loadData" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllSites">Select All</b-button>
            </b-col>
            <b-col cols="12" md="6" lg="4" xl="2" class="mb-1">
              <label class="filter-label">Roles</label>
              <v-select :options="roles" :multiple="true" label="label" v-model="filters.role" @input="loadData" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllRoles">Select All</b-button>
            </b-col>
            <b-col cols="12" md="6" lg="4" xl="2" class="mb-1">
              <label class="filter-label">Users</label>
              <v-select :options="filteredUsers" :multiple="true" label="label" v-model="filters.user" @input="loadData" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllUsers">Select All</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-row>
          <b-col cols="12" lg="6" class="mb-2">
            <b-card>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <h5 class="mb-0">Capacity Utilization Trend</h5>
                <b-button size="sm" variant="success" @click="doExport('exportCapacityUtilizationTrend')">Export</b-button>
              </div>
              <canvas ref="capacityTrend" height="220"></canvas>
            </b-card>
          </b-col>

          <b-col cols="12" lg="6" class="mb-2">
            <b-card>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <h5 class="mb-0">Top Courses (Rolling 6 months)</h5>
                <b-button size="sm" variant="success" @click="doExport('exportTopCoursesRolling')">Export</b-button>
              </div>
              <canvas ref="topCourses" height="220"></canvas>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="6" class="mb-2">
            <b-card>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <h5 class="mb-0">Events Over Time</h5>
                <b-button size="sm" variant="success" @click="doExport('exportEventsOverTime')">Export</b-button>
              </div>
              <canvas ref="eventsOverTime" height="220"></canvas>
            </b-card>
          </b-col>

          <b-col cols="12" lg="6" class="mb-2">
            <b-card>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <h5 class="mb-0">Attendance Trend</h5>
                <b-button size="sm" variant="success" @click="doExport('exportAttendanceTrendOverTime')">Export</b-button>
              </div>
              <canvas ref="attendanceTrend" height="220"></canvas>
            </b-card>
          </b-col>
        </b-row>

       
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import reportStoreModule from './reportStoreModule'
import Chart from 'chart.js'
import vSelect from "vue-select";

export default {
        components: {
      vSelect,
    },
  name: 'TrainingTrends',
  data() {
    return {
      companies: [],
      courses: [],
      sites: [],
      roles: [],
      users: [],
      filters: { company: [], course: [], site: [], role: [], user: [] },
      data: {
        eventsOverTime: [],
        attendanceTrend: [],
        capacityTrend: [],
        topCourses: [],
      },
      charts: { events: null, attendance: null, capacity: null, top: null },
    }
  },
  computed: {
    filteredSites() {
      const ids = (this.filters.company || []).map(c => c.id)
      if (!ids.length) return this.sites
      return this.sites.filter(s => ids.includes(s.company_id))
    },
    filteredUsers() {
      const ids = (this.filters.company || []).map(c => c.id)
      if (!ids.length) return this.users
      return this.users.filter(u => ids.includes(u.company_id))
    },
  },
  created() {
    const MODULE = 'trainingReports'
    if (!store.hasModule(MODULE)) store.registerModule(MODULE, reportStoreModule)
    onUnmounted(() => { if (store.hasModule(MODULE)) store.unregisterModule(MODULE) })
    this.loadOptions().then(this.loadData)
  },
  methods: {
    loadOptions() {
      return store.dispatch('trainingReports/getTrainingOptions').then(res => {
        this.companies = res.data.companies || []
        this.courses = res.data.courses || []
        this.sites = res.data.sites || []
        this.roles = res.data.roles || []
        this.users = res.data.users || []
      })
    },
    selectAllCompanies() {
      this.filters.company = (this.companies || []).slice()
      this.loadData()
    },
    selectAllCourses() {
      this.filters.course = (this.courses || []).slice()
      this.loadData()
    },
    selectAllSites() {
      this.filters.site = this.filteredSites.slice()
      this.loadData()
    },
    selectAllRoles() {
      this.filters.role = (this.roles || []).slice()
      this.loadData()
    },
    selectAllUsers() {
      this.filters.user = this.filteredUsers.slice()
      this.loadData()
    },
    buildParams() {
      const company_id = (this.filters.company || []).map(c => c.id).join(',') || undefined
      const course_id = (this.filters.course || []).map(c => c.id).join(',') || undefined
      const site_id = (this.filters.site || []).map(s => s.id).join(',') || undefined
      const role = (this.filters.role || []).map(r => r.id).join(',') || undefined
      const user_id = (this.filters.user || []).map(u => u.id).join(',') || undefined
      return { company_id, course_id, site_id, role, user_id }
    },
    loadData() {
      const params = this.buildParams()
      store.dispatch('trainingReports/getTrainingTrends', params).then(res => {
        const d = res.data || {}
        this.data.eventsOverTime = d.events_over_time || []
        this.data.attendanceTrend = d.attendance_trend_over_time || []
        this.data.capacityTrend = d.capacity_utilization_trend || []
        this.data.topCourses = d.top_courses_rolling_6_months || []
        this.$nextTick(() => {
          this.renderEventsOverTime()
          this.renderAttendanceTrend()
          this.renderCapacityTrend()
          this.renderTopCourses()
        })
      })
    },
    destroyChart(key) { if (this.charts[key]) { this.charts[key].destroy(); this.charts[key] = null } },
    renderEventsOverTime() {
      this.destroyChart('events')
      const ctx = this.$refs.eventsOverTime.getContext('2d')
      const labels = this.data.eventsOverTime.map(r => r.month)
      const series = this.data.eventsOverTime.map(r => r.events)
      this.charts.events = new Chart(ctx, { type: 'line', data: { labels, datasets: [{ label: 'Events', data: series, borderColor: '#42A5F5', fill: false }] }, options: { scales: { yAxes: [{ ticks: { beginAtZero: true } }] } } })
    },
    renderAttendanceTrend() {
      this.destroyChart('attendance')
      const ctx = this.$refs.attendanceTrend.getContext('2d')
      const labels = this.data.attendanceTrend.map(r => r.month)
      const series = this.data.attendanceTrend.map(r => r.attendees)
      this.charts.attendance = new Chart(ctx, { type: 'line', data: { labels, datasets: [{ label: 'Attendees', data: series, borderColor: '#66BB6A', fill: false }] }, options: { scales: { yAxes: [{ ticks: { beginAtZero: true } }] } } })
    },
    renderCapacityTrend() {
      this.destroyChart('capacity')
      const ctx = this.$refs.capacityTrend.getContext('2d')
      const labels = this.data.capacityTrend.map(r => r.month)
      const cap = this.data.capacityTrend.map(r => r.total_capacity)
      const att = this.data.capacityTrend.map(r => r.total_attended)
      this.charts.capacity = new Chart(ctx, { type: 'line', data: { labels, datasets: [
        { label: 'Total Capacity', data: cap, borderColor: '#9E9E9E', fill: false },
        { label: 'Total Attended', data: att, borderColor: '#29B6F6', fill: false },
      ] }, options: { scales: { yAxes: [{ ticks: { beginAtZero: true } }] } } })
    },
    renderTopCourses() {
      this.destroyChart('top')
      const ctx = this.$refs.topCourses.getContext('2d')
      const labels = this.data.topCourses.map(r => r.course)
      const series = this.data.topCourses.map(r => r.attended)
      this.charts.top = new Chart(ctx, { type: 'horizontalBar', data: { labels, datasets: [{ label: 'Attended', data: series, backgroundColor: '#AB47BC' }] }, options: { scales: { xAxes: [{ ticks: { beginAtZero: true } }] } } })
    },
    doExport(actionName) {
      const params = this.buildParams()
      store.dispatch(`trainingReports/${actionName}`, params).then(res => this.saveBlobResponse(res))
    },
    saveBlobResponse(res) {
      const disposition = res.headers && res.headers['content-disposition']
      const match = disposition && disposition.match(/filename="?([^";]+)"?/)
      const filename = match ? match[1] : 'export.xlsx'
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>

<style scoped>
.filter-panel { background: #f8f8f8; }
.filter-label { font-size: 0.75rem; font-weight: 600; text-transform: uppercase; color: #6e6b7b; margin-bottom: 0.25rem; display: block; }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
